import axios from "axios";
export default {
    getOrders() {
        return axios.get(`/orders?order[id]=desc`);
    },
    getOrder(id) {
        return axios.get(`/orders/${id}`);
    },
    changeStateOrder(id,payload){
        return axios.put(`/orders/${id}`, payload);
    },
    askRefund(id){
        return axios.get(`/orders/refund/${id}`);
    },
    askPartialRefund(payload){
        return axios.post(`/orders/partial/refund`,payload);
    },
    getOrderOutlet(payload,state){
        if(payload.admin){
            return axios.get(`/orders?state=${state}`);
        }else {
            return axios.get(`/orders/outlet/${payload.outlets}/${state}`);
        }
    },
    postComment(payload){
        return axios.post(`/comment_orders`, payload); 
    },
    updateOrder(id,payload){
        return axios.put(`/orders/${id}`, payload);
    },
};
